import {CommentPopupWindow} from "../CommentPopupWindow/CommentPopupWindow";

customElements.define('ep-popup-window', CommentPopupWindow);

export function showComment(id: number, name: string, iconElement: HTMLElement) {

    const popupWindowElement = document.createElement('ep-popup-window') as CommentPopupWindow;
    const elementAttributes = { id: 'comment-popup', 'data-title': name, 'data-text': 'Komentář se načítá...' };

    Object.entries(elementAttributes).forEach(([attributeName, attributeValue]) => {
        popupWindowElement.setAttribute(attributeName, attributeValue);
    });

    popupWindowElement.moveNextTo(iconElement);

    (document.querySelector('body') as HTMLBodyElement).prepend(popupWindowElement);

    const fetchUrl = '/share/epSnow/epSnowGetCommentAsJson.php';
    const fetchOptions = {
        method: 'POST',
        mode: 'same-origin',
        cache: 'no-cache',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({id: id}) // body data type must match "Content-Type" header
    };

    fetch(fetchUrl, fetchOptions as RequestInit)
        .then(response => response.json())
        .then(commentText => popupWindowElement.setAttribute('text', commentText));
    //.catch((error) => console.error('Error:', error));

}